import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    UpdateGiftVoucherDocument,
    type UpdateGiftVoucherMutation,
    type UpdateGiftVoucherMutationVariables,
} from '../../../../api/mutations/updateGiftVoucher';
import { type GiftVoucherKYCJourneyValues } from './KYCPage/shared';

const useUpdateGiftVoucher = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (values: GiftVoucherKYCJourneyValues, token: string) => {
            const { data } = await apolloClient.mutate<UpdateGiftVoucherMutation, UpdateGiftVoucherMutationVariables>({
                mutation: UpdateGiftVoucherDocument,
                variables: {
                    numberOfBookingReferenceDays: values.numberOfBookingReferenceDays,
                    stockId: values.stockId,
                    value: values.value,
                    token,
                },
            });

            return data.result;
        },
        [apolloClient]
    );
};

export default useUpdateGiftVoucher;
